var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4667 0H1.2C0.537258 0 0 0.537259 0 1.2V25.4667C0 26.1294 0.537259 26.6667 1.2 26.6667H25.4667C26.1294 26.6667 26.6667 26.1294 26.6667 25.4667V1.2C26.6667 0.537258 26.1294 0 25.4667 0Z",
    transform: "scale(0.75)",
    fill: "#3d5e69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73828 0C6.73828 0 2.52369 3.91006e-06 1.46589 0.27487C0.8995 0.433123 0.433125 0.899503 0.27487 1.47422C6.26246e-06 2.53203 0 4.72266 0 4.72266C0 4.72266 6.26246e-06 6.9216 0.27487 7.96276C0.433125 8.53747 0.89117 8.99552 1.46589 9.15378C2.53202 9.43697 6.73828 9.43698 6.73828 9.43698C6.73828 9.43698 10.9612 9.43697 12.019 9.16211C12.5937 9.00385 13.0518 8.55413 13.2017 7.97109C13.4849 6.92161 13.4849 4.73099 13.4849 4.73099C13.4849 4.73099 13.4932 2.53203 13.2017 1.47422C13.0518 0.899503 12.5937 0.441463 12.019 0.291536C10.9612 1.33197e-05 6.73828 0 6.73828 0ZM5.39727 2.6987L8.90391 4.72266L5.39727 6.73828V2.6987Z",
    transform: "translate(3.25757 5.28174)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.76d12df383bf91506807ae0b69dafcd0.svg";
export { ForwardRef as ReactComponent };